import React , {Component} from "react";
import MyContext from '../MyContext.jsx';
import {Link} from "react-router-dom";
import { CgSearch } from 'react-icons/cg';
import Select from "react-select";

import './PriceList.scss';

class PriceList extends Component{
  constructor(props){
    super(props);
    this.state = {
      products:[],
      showing_products:[]
    }
    this.formChange = this.formChange.bind(this);
    this.processPDFEstimate = this.processPDFEstimate.bind(this);
  }
  componentDidMount(){
    var obj_this = this;
    const url2 = `${process.env.REACT_APP_SSS}/api/getProductList`;
    this.context.loading(1);
    $.ajax({
      url : url2,
      data : {
        sid : this.context.user_details.sid,
      },
      type : "POST"
    }).done(function(return_data){
     
      if(return_data.status == "success"){
        var active_products = return_data.active_products;
        obj_this.setState({
         products : active_products,
         showing_products : active_products
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      obj_this.context.loading(0);
      alert("Network error");
    });
  }

  formChange(e){
    var showing_products =[];
    if(e.target.value){
      showing_products = this.state.products.filter((item) => {return item.name.toLowerCase().includes(e.target.value.toLowerCase())});
    }
    else{
      showing_products = this.state.products;
    }
    this.setState({
      showing_products : showing_products
    });
  }

  pdfButtonClick = () => {
    this.processPDFEstimate();
  };

  processPDFEstimate(e) {
    var obj_this = this;
    obj_this.context.loading(1);
    var state_object = this.state.showing_products;
    console.log(state_object);
    if (window.cordova) {

      let options = {
        documentSize: 'A4',
        type: "base64",
        fileName: obj_this.context.user_details.division.label + '-pricelist' + '.pdf'
      }

      var text = `
        <html>
          <head>
        <style>
          @page {
            size: A4;
            margin: 20mm;
          }
          body {
            font-family: Arial, sans-serif;
            margin: 20mm;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 20px;
          }
          th, td {
            border: 1px solid #000;
            padding: 8px;
            text-align: center;
            font-size: 10px;
          }
          th {
            background-color: #f2f2f2;
          }
          h4 {
            text-align: center;
            font-weight: bold;
            text-decoration: underline;
            margin-bottom: 10px;
          }
        </style>
          </head>
          <body>
        <h4>PRICE LIST</h4>
        <table>
          <thead>
            <tr>
          <th>Sl No.</th>
          <th>Product Name</th>
          <th>Unit</th>
          <th>PTS</th>
          <th>PTR</th>
          <th>MRP</th>
            </tr>
          </thead>
          <tbody>
      `;

      for (var i = 0; i < state_object.length; i++) {

        text = text + '<tr><td align="center">' + [i + 1] + '</td>';
        text = text + '<td align="left">' + state_object[i].name + '</td>';
        text = text + '<td align="center">' + state_object[i].price?.unit + '</td>';
        text = text + '<td align="right">' + parseFloat(state_object[i].price?.pts??0).toFixed(2) + '</td>';
        text = text + '<td align="right">' + parseFloat(state_object[i].price?.ptr??0).toFixed(2) + '</td>';
        text = text + '<td align="right">' + parseFloat(state_object[i].price?.mrp??0).toFixed(2) + '</td></tr>';
      }

     text = text + ' <tr><th colSpan="6" align="right">Generated on '+new Date().toLocaleString('en-IN')+ '</th></tr>';
      text = text + '</tbody></table>';

      pdf.fromData(text, options)
        .then((base64) => {
          obj_this.savePDF(base64, options.fileName);

        })
        .catch((err) => console.log(err));
      obj_this.context.loading(0);


    }
    obj_this.context.loading(0);

  }


  b64toBlob(b64Data, contentType) {
    contentType = contentType || '';
    var sliceSize = 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  savePDF(base64Data, fileName) {
    var blob = this.b64toBlob(base64Data, 'application/pdf');
    var blobUrl = URL.createObjectURL(blob);
    console.log('Documents Directory URL:', cordova.file.dataDirectory);
    var self = this; // Store a reference to 'this'
  
    document.addEventListener('deviceready', function () {
        window.resolveLocalFileSystemURL(cordova.file.dataDirectory, function (dirEntry) {
            dirEntry.getFile(fileName, { create: true }, function (fileEntry) {
                fileEntry.createWriter(function (fileWriter) {
                    fileWriter.onwriteend = function () {
                        console.log("Successful file write:", fileName);
                        // Read the file after writing (if needed)
                        self.sharePDF(fileEntry.toURL(), 'application/pdf');
                    };
  
                    fileWriter.onerror = function (e) {
                        console.log("Failed file write:", e.toString());
                    };
  
                    fileWriter.write(blob); // Write the Blob to the file
                }, function (err) {
                    console.error('Error creating file writer:', err);
                });
            }, function (err) {
                console.error('Error getting file:', err);
            });
        }, function (err) {
            console.error('Error resolving file system URL:', err);
        });
    });
  }
  
  sharePDF(fileUrl, mimeType) {
    window.plugins.socialsharing.share(null, null, fileUrl, null, function (err) {
      console.error('Error sharing PDF:', err);
    }, {
        subject: 'Share PDF', // Subject for the sharing action
        mimeType: mimeType // Specify the MIME type of the file being shared
    });
  }

  
  render(){
    return(
      <MyContext.Consumer>
        {context => (
        <div className="price_list_page_container">
          <div className="page_header">
            <Link className="back_button" to="/home"><i className="fas fa-arrow-left"></i></Link>
            <div className="page_title">Price List</div>
          </div> 
          <div className="grid_container">
            <div className="search_container">
              <CgSearch />
              <input className="product_search_input"
                placeholder="Search product.."
                onChange={this.formChange}
              />
            </div>
            <button className="submit_button" onClick={this.pdfButtonClick}>PDF</button>
          </div>
          <div className="table_container">
            <table className="products_price_table">
              <thead>
                <tr>
                  <th style={{maxWidth:"40px"}} align="center">#</th>
                  <th>Product</th>
                  <th>Unit</th>
                  <th>PTS</th>
                  <th>PTR</th>
                  <th>MRP</th>
                </tr>
              </thead>
              <tbody>
              <tr style={{display:this.state.showing_products.length?"none":"table-row"}}>
                <td colSpan="2" align="center">No result!</td>
              </tr>
              {this.state.showing_products && this.state.showing_products.map((cust,index) => (
                <tr key={index} >
                  <td valign="top" align="center">{index+1}</td>
                  <td valign="top">{cust.name}</td>
                  <td valign="top">{cust.price?.unit}</td>
                  <td valign="top">{cust.price?.pts}</td>
                  <td valign="top">{cust.price?.ptr}</td>
                  <td valign="top">{cust.price?.mrp}</td>
              </tr>
              ))}
              </tbody>
            </table>
          </div>
        </div>

      )}
    </MyContext.Consumer>
  )}
}

export default PriceList;
PriceList.contextType = MyContext;
